module.exports = __webpack_public_path__ + "media/packs/images/search/pickup-bfe5fed93fa2c6c05e7b9ae47f8c5d61.svg";